/* global GOOGLE_API_KEY:true */
import React, { useState, useRef, useMemo } from "react";
import { Card, Tooltip, Spin } from "antd";
import GoogleMapReact from "google-map-react";
import { Link } from "umi";
import useSupercluster from "use-supercluster";
import { ShipmentStatus } from "@/utils/enum";
import ClusterMarker from "@/components/MapMarkers/ClusterMarker/ClusterMarker";
import { useGetShipmentMarkers } from "@/pages/AvailableShipments/utils/useGetShipmentMarkers.js";
import styles from "./style.less";

const defaultZoom = window.innerWidth <= 768 ? 3 : 4.25;

const LoadToolTip = props => (
  <>
    <p style={{ color: "black", margin: "5px 0" }}>Pickup: {props.shipmentProps.pickUpAddress}</p>
    <p style={{ color: "black", margin: "5px 0" }}>Drop off: {props.shipmentProps.dropOffAddress}</p>
    <Link to={props.shipmentProps.detailsLinkUrl}>Click for more details</Link>
  </>
);

const LoadMarker = props => (
  <Tooltip title={<LoadToolTip shipmentProps={props} />} color="white">
    <div className={styles.pulseIcon}></div>
  </Tooltip>
);

const renderMarkers = shipmentData => {
  return shipmentData?.map(shipment => ({
    type: "Feature",
    properties: {
      cluster: false,
      shipmentId: shipment.id,
      status: ShipmentStatus.Posted,
      detailsLinkUrl: `/loads/shipments/view?shipmentId=${shipment.id}`,
      pickUpAddress: shipment.pickupAddress,
      dropOffAddress: shipment.dropOffAddress,
    },
    geometry: {
      type: "Point",
      coordinates: [shipment.pickupLongitude, shipment.pickupLatitude],
    },
  }));
};

export default function AllShipmentsMap() {
  const mapRef = useRef();
  const [bounds, setBounds] = useState(null);
  const [zoom, setZoom] = useState(defaultZoom);
  const { data: shipmentMarkers, loading } = useGetShipmentMarkers();

  const points = useMemo(() => {
    return renderMarkers(shipmentMarkers);
  }, [shipmentMarkers]);

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    options: {
      radius: 75,
      maxZoom: 20,
    },
  });

  if (loading) {
    <Card style={{ marginBottom: 16 }}>
      <div style={{ width: "100%", textAlign: "center" }}>
        <Spin />
      </div>
    </Card>;
  }

  return (
    <Card
      style={{
        marginBottom: 16,
      }}
    >
      <div
        style={{
          height: 500,
        }}
      >
        <GoogleMapReact
          bootstrapURLKeys={{
            key: GOOGLE_API_KEY,
          }}
          defaultCenter={{
            lat: 39,
            lng: -98,
          }}
          defaultZoom={defaultZoom}
          onChange={({ zoom, bounds }) => {
            setZoom(zoom);
            setBounds([bounds.nw.lng, bounds.se.lat, bounds.se.lng, bounds.nw.lat]);
          }}
          onGoogleApiLoaded={({ map }) => {
            mapRef.current = map;
          }}
          yesIWantToUseGoogleMapApiInternals
        >
          {clusters.map(cluster => {
            const [lng, lat] = cluster.geometry.coordinates;
            const { cluster: isCluster, point_count: clusterPointCount } = cluster.properties;

            if (isCluster) {
              return (
                <ClusterMarker
                  key={cluster.id}
                  mapRef={mapRef}
                  clusterId={cluster.id}
                  supercluster={supercluster}
                  lat={lat}
                  lng={lng}
                  clusterPointCount={clusterPointCount}
                  totalPointCount={points?.length ?? 0}
                />
              );
            }

            return (
              <LoadMarker
                key={cluster.properties.shipmentId}
                lat={lat}
                lng={lng}
                status={cluster.properties.status}
                detailsLinkUrl={cluster.properties.detailsLinkUrl}
                pickUpAddress={cluster.properties.pickUpAddress}
                dropOffAddress={cluster.properties.dropOffAddress}
              />
            );
          })}
        </GoogleMapReact>
      </div>
    </Card>
  );
}
